import { useState } from 'react'
import { Trans } from 'react-i18next'

import { useDelayedContinue } from '~/shared/hooks/useDelayedContinue'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

import { Styles as S } from './styles'

export interface IImageChoiceQuizOption {
  key: string
  i18nKey: string
}

export interface IImageChoiceQuizProps extends TPageProps {
  ns: string
  question: string
  questionI18nKey: string
  optionsI18nKeyPrefix: string
  options: readonly IImageChoiceQuizOption[]
  image: {
    png: string
    webp: string
    alt: string
  }
}

export const ImageChoiceQuiz = ({
  nextPagePath,
  pageId,
  ns,
  question,
  questionI18nKey,
  optionsI18nKeyPrefix,
  options,
  image,
}: IImageChoiceQuizProps) => {
  const [answer, setAnswer] = useState('')
  const { isAnswersDisabled, handleChange, setIsAnswersDisabled } =
    useDelayedContinue()

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question,
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <S.Question>
          <Trans ns={ns} i18nKey={questionI18nKey} />
        </S.Question>

        <S.ImageWrapper>
          <picture>
            <source srcSet={image.webp} type="image/webp" />
            <img src={image.png} alt={image.alt} />
          </picture>
        </S.ImageWrapper>

        <S.OptionsGrid>
          {options.map(({ key, i18nKey }) => (
            <S.OptionButton
              key={key}
              type="button"
              $isSelected={answer === key}
              disabled={isAnswersDisabled}
              onClick={() => {
                setAnswer(key)
                setIsAnswersDisabled(true)
                handleChange(key, handleContinue)
              }}
            >
              <Trans
                ns={ns}
                i18nKey={`${optionsI18nKeyPrefix}.${i18nKey}`}
                components={{ emoji: <S.EmojiSpan /> }}
              />
            </S.OptionButton>
          ))}
        </S.OptionsGrid>
      </S.StyledContainer>
    </S.Root>
  )
}
